import * as types from './constants';

// Get Link Meta
export const getLinkMetaRequest = data => (
  { type: types.GET_LINK_META_REQUEST, payload: data }
);

export const getLinkMetaDone = data => (
  { type: types.GET_LINK_META_DONE, payload: data }
);

export const getLinkMetaFailed = errors => (
  { type: types.GET_LINK_META_FAILED, payload: errors }
);

export const getLinkMetaReset = () => (
  { type: types.GET_LINK_META_RESET }
);